export const signatures = {
    margin: [0, 20, 0, 0],
    fontSize: 10,
    columns: [

        {
            width: '25%',
            text: 'Лицо, ответственное за выполнение работ',
        },
        {
            width: '25%',
            stack: [
                {
                    svg: '<svg viewBox="0 0 100 30" xmlns="http://www.w3.org/2000/svg"><line x1="0" y1="30" x2="140" y2="30" stroke="black" /></svg>'
                },
                {
                    text: 'ФИО Подпись',
                    alignment: 'center'
                }
            ],
        },

        {
            width: '25%',
            text: 'С качеством, объемом и стоимостью работ, з/ч и материалов согласен',
        },
        {
            width: '25%',
            stack: [
                {
                    svg: '<svg viewBox="0 0 100 30" xmlns="http://www.w3.org/2000/svg"><line x1="0" y1="30" x2="140" y2="30" stroke="black" /></svg>'
                },
                {
                    text: 'ФИО Подпись',
                    alignment: 'center'
                }
            ],
        },
    ]
}